module.exports = __webpack_public_path__ + "img/11_72.71f72cec.png";